import React from "react";
import { useParams } from "react-router-dom";
import Transactions from "us.collection.transactions";
import { CaseType } from 'us.helper/types/enums';
import { useNavigate, useLocation } from "react-router-dom";
import { INavigationData } from 'us.collection/interfaces';

interface ICntSelectedCreditorsHome {
  caseType: CaseType
}

const Cnt_TransactionsHome: React.FC<ICntSelectedCreditorsHome> = (
  props
) => {
  const { arNumber } = useParams<{ arNumber: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as INavigationData;

  const onMinimize = () => {
    navigate(`/ar/${arNumber}`, { state });
  };

  return (
    <>
      <Transactions.Components.ArTransactions
        onMinimize={onMinimize}
        {...props}
      />
    </>
  );
};

export default Cnt_TransactionsHome;
